import { Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { formatCurrencyFloat } from 'shared/utils/numberFormatters';
import { calculateMonthlyRentSummary } from '../helpers';
import { useMemo } from 'react';
import { Table } from 'components/shared/Table';

type SummaryTableProps = {
  compGroup: any;
  subjectUnitGroups: any[];
};

const SummaryTable = observer(({ compGroup, subjectUnitGroups }: SummaryTableProps) => {
  const { bedrooms, comps } = compGroup;
  const columns = useMemo(() => {
    return [
      {
        field: 'compGroup',
        headerName: bedrooms === 0 ? 'Studio' : `${bedrooms} Bedroom${bedrooms > 1 ? 's' : ''}`,
        editable: false,
        flex: 1,
      },
      {
        field: 'min',
        headerName: 'Min',
        editable: false,
      },
      {
        field: 'avg',
        headerName: 'Avg',
        editable: false,
      },
      {
        field: 'max',
        headerName: 'Max',
        editable: false,
      },
    ];
  }, [bedrooms]);
  const subjectUnits = subjectUnitGroups.find((group) => group.bedrooms === bedrooms)?.units || [];
  const rentSummary = calculateMonthlyRentSummary(subjectUnits, comps);

  const rows = [
    {
      id: 0,
      compGroup: 'Subject Units',
      min: formatCurrencyFloat(rentSummary.subjectUnits.min),
      avg: formatCurrencyFloat(rentSummary.subjectUnits.average),
      max: formatCurrencyFloat(rentSummary.subjectUnits.max),
    },
    {
      id: 1,
      compGroup: 'Comps',
      min: formatCurrencyFloat(rentSummary.comps.min),
      avg: formatCurrencyFloat(rentSummary.comps.average),
      max: formatCurrencyFloat(rentSummary.comps.max),
    },
  ];

  return (
    <Grid xs={4} pb={1}>
      <Table rows={rows} columns={columns} />
    </Grid>
  );
});

export { SummaryTable };
